module.exports = __webpack_public_path__ + "488638bc710398d51a9283a6c394615a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/help/help-webchat-en.png
// module id = 461
// module chunks = 0